module.exports = __webpack_public_path__ + "static/img/01t.e2dc1ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/thumbnails/01t.jpg
// module id = 617
// module chunks = 0